import { render } from "./post3Page.vue?vue&type=template&id=7043eaa6"
import script from "./post3Page.vue?vue&type=script&lang=js"
export * from "./post3Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__